"use client";
import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const socialSharingIconsInputs = [
  {
    name: "alignment",
    type: "string",
    enum: ["start", "center", "end"],
    defaultValue: "center",
    required: true,
  },
  {
    name: "items",
    type: "list",
    required: false,
    subFields: [
      {
        name: "icon",
        type: "string",
        enum: [
          "social-facebook",
          "social-facebook-messenger",
          "social-line",
          "social-telegram",
          "social-instagram",
          "social-snapchat",
          "social-mail",
          "social-x",
          "social-viber",
          "social-whatsapp",
          "social-youtube",
          "social-imessage",
        ],
        defaultValue: "social-facebook",
        required: true,
      },
      {
        name: "url",
        type: "url",
        required: false,
      },
    ],
  },
] as const satisfies Inputs;

export type SocialSharingIconsProps = BuilderComponentProps<
  typeof socialSharingIconsInputs
>;

export const SocialSharingIconsComponent: RegisteredComponent = {
  name: "SocialSharingIcons",
  component: withValidation(
    socialSharingIconsInputs,
    dynamic(() =>
      import("./SocialSharingIcons").then((mod) => mod.SocialSharingIcons)
    ),
    "SocialSharingIcons"
  ),
  inputs: socialSharingIconsInputs,
};
